module.exports = __webpack_public_path__ + "static/media/callsdb.97c34818.svg";